import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import { Form, Modal } from 'semantic-ui-react';
import { isMobileOnly } from 'mobile-device-detect';
import { Button } from 'semantic-ui-react';
import { useTextResources } from '../../language';
import HotelsDropDown from '../shared/HotelsDropDown';
import CurrencyDropDown from '../shared/CurrencyDropDown';
import NumericInput from '../shared/NumericInput';
import GridPanel from '../GridPanel';
import { RoomTypes } from '../../api/services/next'
import { onWarning } from '../shared/messages';
import { ChainAddonsDropDown } from '../shared/ChainAddonsDropDown';

const MultipleCommissionPopup = ({ controller, ...rest }) => {
    const text = useTextResources();
    const [open, setOpen] = useState(false);
    const [roomTypes, setRoomTypes] = useState([]);
    const [selectedExtraAddon, setSelectedExtraAddon] = useState();
    const [selectedHotel, setSelectedHotel] = useState();
    const [selectedRoomTypes, setSelectedRoomTypes] = useState([]);
    const [commissionPercent, setCommissionPercent] = useState(0);
    const [fixedCommissionAmount, setFixedCommissionAmount] = useState(0);
    const [selectedCurrency, setSelectedCurrency] = useState();
    const [params, setParams] = useState({});

    useEffect(() => {
        if (controller) {
            window[controller] = (action, params) => {
                setParams(params);
                if (action === "open"){
                    setOpen(true);
                    // reset state whenever popup is opened so it wouldn't last open's state
                    setSelectedExtraAddon();
                    setSelectedHotel();
                    setSelectedRoomTypes([]);
                    setCommissionPercent(0);
                    setFixedCommissionAmount(0);
                    setSelectedCurrency();
                }
            }
        }
        (async () => {
            const fetchedRoomTypes = await RoomTypes.GetRoomTypes({})
            setRoomTypes(fetchedRoomTypes);
        })()

    }, []);

    const gridOptions = {
        columns: [
            { name: 'Name', title: text("RoomType") }
        ],
        selectable: true
    }

    const isValid =  () => {
        if (fixedCommissionAmount > 0) {
            return (params.CustomerId !== -1 && selectedHotel && selectedRoomTypes.length > 0 && selectedCurrency);
        }
        else {
            return (params.CustomerId !== -1 && selectedHotel && selectedRoomTypes.length > 0 && commissionPercent > 0 && Boolean(!params.isForAddons || selectedExtraAddon !== undefined));
        }
    }

    const updateTable = async () => {
        if (await isValid()) {
            params.addRows(selectedRoomTypes.map(roomType => ({
                CustomerID: params.CustomerId,
                Hotel: selectedHotel,
                RoomType: roomTypes[roomType],
                CommissionPercent: commissionPercent || undefined,
                FixedCommissionAmountBeforeTax: fixedCommissionAmount || undefined,
                ExtraAddon: selectedExtraAddon,
                Currency: fixedCommissionAmount > 0 ? selectedCurrency : undefined,
            })));
            setOpen(false);
        }
        else {
            onWarning("Missing fields. please select hotel, room type(s) currency, and commission amout or percentage.")
        }
    }

    return <Modal size={isMobileOnly ? "fullscreen" : "tiny"} open={open} onClose={() => setOpen(false)} className={isMobileOnly ? "mobile" : ""} style={{ zIndex: 1000000 }} {...rest} >
        {!isMobileOnly &&
            <Modal.Header>{params.isForAddons ? text("ExtraAddOnCommission") : text("HotelCustomerProductCommissions")}</Modal.Header>
        }
        <Modal.Content>
            <Form>
                <Form.Field
                    label={text("Hotel")}
                    placeholder={text("SelectHotel")}
                    onChangeItem={setSelectedHotel}
                    control={HotelsDropDown}
                />
                <Form.Field
                    label={text("CommissionPercent")}
                    type="number"
                    onChange={setCommissionPercent}
                    control={NumericInput}
                    min={0}
                    max={100}
                    disabled={fixedCommissionAmount > 0}
                />
                {!params.isForAddons && <Form.Field
                    label={text("FixedCommissionAmountBeforeTax")}
                    type="number"
                    onChange={setFixedCommissionAmount}
                    min={0}
                    control={NumericInput}
                    disabled={commissionPercent > 0}
                />}
                {fixedCommissionAmount > 0 &&
                    <Form.Field
                        label={text("Currency")}
                        placeholder="Select Currency"
                        onChangeItem={setSelectedCurrency}
                        control={CurrencyDropDown}
                    />}
                {params.isForAddons &&
                    <Form.Field
                        required
                        label={text("ExtraAddOn")}
                        placeholder="Select Extra Addon"
                        control={ChainAddonsDropDown}
                        onChangeItem={setSelectedExtraAddon}
                    />
                }
            </Form>
            <div style={{ display: "flex", marginTop: 10, height: 300, overflow: "hidden" }}>
                <GridPanel data={roomTypes} onSelected={(items) => setSelectedRoomTypes(items)} options={gridOptions} />
            </div>
        </Modal.Content>
        <Modal.Actions>
            {!isMobileOnly && <Button size={"small"} negative onClick={() => setOpen(false)}>{text("Close")}</Button>}
            <Button size={"small"} positive onClick={updateTable}>{text("Save")}</Button>
        </Modal.Actions>
    </Modal>


}

MultipleCommissionPopup.propTypes = {
    controller: PropTypes.any,
}

export default MultipleCommissionPopup;